import { Navigate, Route, Routes } from "react-router-dom";
import BlogNav from "./BlogNav";
import { AdminLayout } from "../../layouts/DashboardLayout";
import DashboardPage from "../../pages/DashboardPage";
import ReviewNav from "./ReviewNav";
import FaqNav from "./FaqNav";
import JobOfferNav from "./JobOfferNav";
import CandidatureNav from "./CandidatureNav";
import SiteNav from "./SiteNav";
import LocaleNav from "./LocaleNav"
import PageNav from "./PageNav";
import MediaNav from './MediaNav'

export default function MainNav() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/blog" element={<Navigate to="/blog/posts" replace />} />
        <Route path="/blog/posts/*" element={<BlogNav />} />
        <Route path="/reviews/*" element={<ReviewNav />} />
        <Route path="/job-offers/*" element={<JobOfferNav />} />
        <Route path="/faq/*" element={<FaqNav />} />
        <Route path="/candidatures/*" element={<CandidatureNav />} />
        <Route path="/sites/*" element={<SiteNav />} />
        <Route path="/locales/*" element={<LocaleNav />} />
        <Route path="/pages/*" element={<PageNav />} />
        <Route path="/media/*" element={<MediaNav />} />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AdminLayout>
  );
}